import React from 'react';

import { Pill } from '@/components/common/Pill';

interface CompanionLabelProps {
  memberCount: number;
  isPrimary: boolean;
  size?: 'sm' | 'md' | 'lg';
}

/**
 * Formats companion text for inline display.
 * @example `${matterName}${formatCompanionText(3, true)}` → "John Doe – 3 Pack Primary"
 */
export const formatCompanionText = (
  memberCount: number,
  isPrimary: boolean,
): string => {
  if (memberCount < 2) return '';

  const label = isPrimary
    ? `${memberCount} Pack Primary`
    : `${memberCount} Pack`;
  return ` – ${label}`;
};

/**
 * Badge showing companion case status. Use size="sm" in tables, defaults to "md".
 * For inline text, use formatCompanionText() instead.
 */
export const CompanionLabel: React.FC<CompanionLabelProps> = ({
  memberCount,
  isPrimary,
  size = 'md',
}) => {
  // Only show if part of a companion set (2+ members)
  if (memberCount < 2) return null;

  const label = isPrimary
    ? `${memberCount} Pack Primary`
    : `${memberCount} Pack`;

  return (
    <Pill variant="gray" size={size} aria-label={label}>
      {label}
    </Pill>
  );
};

export default CompanionLabel;
